import { ThemeEvents } from '@theme/events';

/**
 * Restrained "Only N left" scarcity indicator.
 * Re-evaluates against the newly selected variant on every variant:update event.
 * The initial state is rendered server-side by blocks/product-scarcity.liquid.
 */
class ProductScarcity extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section') ?? document;
    this.onVariantUpdate = this.handleVariantUpdate.bind(this);
    this.scope.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  /** @param {CustomEvent} event */
  handleVariantUpdate(event) {
    const variant = event.detail?.resource;
    const threshold = parseInt(this.dataset.threshold || '5', 10);
    const textEl = this.querySelector('.product-scarcity__text');

    if (!variant) {
      this.hidden = true;
      return;
    }

    // inventory_management is a truthy string ("shopify") when tracked, null/empty when not.
    const isTracked = variant.inventory_management != null && variant.inventory_management !== '';
    const qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;

    if (isTracked && qty !== null && qty > 0 && qty <= threshold) {
      const template = this.dataset.message || 'Only [qty] left';
      if (textEl) textEl.textContent = template.replace('[qty]', String(qty));
      this.hidden = false;
    } else {
      this.hidden = true;
    }
  }
}

if (!customElements.get('product-scarcity')) {
  customElements.define('product-scarcity', ProductScarcity);
}
